"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getImageSourcesCount_1 = __importDefault(require("./definables/getImageSourcesCount"));
const state_1 = __importDefault(require("../state"));
const getAudioSourcesCount_1 = __importDefault(require("./definables/getAudioSourcesCount"));
const assetsAreLoaded = () => state_1.default.loadedAssets === (0, getImageSourcesCount_1.default)() + (0, getAudioSourcesCount_1.default)() + 1;
exports.default = assetsAreLoaded;
